import type {AutomationWorkflowAudienceAction} from 'src/action-creators/automation-workflow-audience';
import type {AudienceList} from 'src/types/audience-list';
import type {TalentPoolHierarchy} from 'src/types/talent-pools';
import {
  UPDATE_STATE,
  RECEIVE_SELECTED_LISTS,
  SET_INCLUDED_LISTS,
  SET_EXCLUDED_LISTS,
  SET_TALENT_POOL_INCLUDED_LISTS,
  SET_TALENT_POOL_EXCLUDED_LISTS,
  RESET,
} from 'src/action-creators/automation-workflow-audience';


export type AutomationWorkflowAudienceState = {
  includedLists: Map<string, Partial<AudienceList>>;
  excludedLists: Map<string, Partial<AudienceList>>;
  talentPoolIncludedLists: Map<string, Partial<TalentPoolHierarchy>>;
  talentPoolExcludedLists: Map<string, Partial<TalentPoolHierarchy>>;
};

const initialState = {
  includedLists: new Map(),
  excludedLists: new Map(),
  talentPoolIncludedLists: new Map(),
  talentPoolExcludedLists: new Map(),
} as const;

export default (
  state: AutomationWorkflowAudienceState = initialState,
  action: AutomationWorkflowAudienceAction,
): AutomationWorkflowAudienceState => {
  switch (action.type) {
    case UPDATE_STATE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case RECEIVE_SELECTED_LISTS: {
      return {
        ...state,
        includedLists: new Map([
          ...state.includedLists.entries(),
          ...action.payload.includedLists.entries(),
        ]),
        excludedLists: new Map([
          ...state.excludedLists.entries(),
          ...action.payload.excludedLists.entries(),
        ]),
      };
    }
    case SET_INCLUDED_LISTS: {
      return {
        ...state,
        includedLists: action.payload,
      };
    }
    case SET_EXCLUDED_LISTS: {
      return {
        ...state,
        excludedLists: action.payload,
      };
    }
    case SET_TALENT_POOL_INCLUDED_LISTS: {
      return {
        ...state,
        talentPoolIncludedLists: action.payload,
      };
    }
    case SET_TALENT_POOL_EXCLUDED_LISTS: {
      return {
        ...state,
        talentPoolExcludedLists: action.payload,
      };
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
  }

  return state;
};
